var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"screenfull"}},[_c('span',{class:[
      'iconfont',
      _vm.isScreenfull ? 'icon-tuichuquanping' : 'icon-quanping',
    ],on:{"click":_vm.toggle}})])
}
var staticRenderFns = []

export { render, staticRenderFns }